"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ConstructionGallery() {
  const tickerItems = ["PRECISION", "QUALITY", "CONCRETE", "STRUCTURE", "VANCOUVER", "SAFETY", "EXCELLENCE", "PRECISION", "QUALITY", "CONCRETE", "STRUCTURE", "VANCOUVER"];
  const collageImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/concrete_formwork_site.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/concrete_formwork_site.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/concrete_formwork_site.png-wvc-sizes",
    alt: "Concrete formwork installation on a construction site",
    caption: "FORMWORK SYSTEMS"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/skilled_labor_team.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/skilled_labor_team.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/skilled_labor_team.png-wvc-sizes",
    alt: "Skilled construction crew working on site",
    caption: "PROFESSIONAL CREW"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/structural_concrete_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/structural_concrete_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/structural_concrete_detail.png-wvc-sizes",
    alt: "Close-up of structural concrete reinforcement",
    caption: "STRUCTURAL INTEGRITY"
  }];
  return;
}